<template>
  <div class="wp-block-button is-style-btn-primary-action" @click="gorDetail">
    <a
      aria-current="page"
      href="javascript:void(0)"
      class="router-link-active router-link-exact-active wp-block-button__link wp-element-button"
      ><span class="text">{{ $t('searchJob.jobApplyNow') }}</span
      ><span class="arrow"
        ><svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 18 18"
        >
          <path
            fill="#000"
            d="M17.681 4.598a1.091 1.091 0 0 0-1.874.741l-.142 8.783L2.058.514A1.091 1.091 0 0 0 .515 2.057l13.607 13.608-8.782.141a1.091 1.091 0 0 0 .035 2.182l11.357-.184a1.09 1.09 0 0 0 1.073-1.073l.184-11.357c.005-.3-.114-.575-.308-.776Z"
          ></path></svg></span
    ></a>
  </div>
</template>

<script setup>
const emit = defineEmits(['goDetail'])

const gorDetail =()=>{
  emit('goDetail')
}
</script>

<style lang="scss" scoped>
.wp-block-button .wp-element-button {
  height: 80px;
  line-height: 80px;
}

@media (max-width: 768px) {
  .wp-block-button .wp-element-button {
    width: 100%;
    height: 48px;
    line-height: 48px;

    .text {
      text-align: center;
    }

    .arrow {
      display: none;
    }
  }
}
</style>
